export type EventEntryCategoryId = 'general' | 'affiliate';
export type EventBenefitCategoryCode = '01' | '02';
export type EventCategoryIconId = 'place' | 'shop';

export interface EventEntryCategory {
    id: EventEntryCategoryId;
    code: EventBenefitCategoryCode;
    titleKey: string;
    subtitleKey: string;
    ctaKey: string;
    icon: EventCategoryIconId;
    /** Benefit group name from Lotte API (no spaces) */
    badgeKey: string;
}

export const EVENT_BENEFIT_CATEGORY_CODES = {
    AFFILIATE: '01',
    GENERAL: '02',
} as const;

export const EVENT_ENTRY_CATEGORIES: EventEntryCategory[] = [
    {
        id: 'general',
        code: EVENT_BENEFIT_CATEGORY_CODES.GENERAL,
        titleKey: 'event.category.general.title',
        subtitleKey: 'event.category.general.subtitle',
        ctaKey: 'event.category.general.cta',
        icon: 'place',
        badgeKey: '일반혜택',
    },
    {
        id: 'affiliate',
        code: EVENT_BENEFIT_CATEGORY_CODES.AFFILIATE,
        titleKey: 'event.category.affiliate.title',
        subtitleKey: 'event.category.affiliate.subtitle',
        ctaKey: 'event.category.affiliate.cta',
        icon: 'shop',
        badgeKey: '제휴혜택',
    },
];

export const EVENT_FILTER_ALL = 'all';

export const EVENT_LIST_PAGE_SIZE = 6;
export const EVENT_LIST_PAGE_SIZE_HALF = 3;

export const EVENT_CATEGORY_CODE_SET = new Set<string>(EVENT_ENTRY_CATEGORIES.map((category) => category.code));

export function getEventEntryCategoryByCode(code: string): EventEntryCategory | undefined {
    return EVENT_ENTRY_CATEGORIES.find((category) => category.code === code);
}
